import React, { useState } from "react";
import Sidebar from "./Sidebar";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { RxHamburgerMenu } from "react-icons/rx";

const Dashboard = () => {
  // const [isDragging, setIsDragging] = useState(false);

  // const handleDragStart = (event) => {
  //   event.dataTransfer.setData("text/plain", event.target.id);
  //   setIsDragging(true);
  // };

  // const handleDragEnd = () => {
  //   setIsDragging(false);
  // };

  // const handleDrop = (event) => {
  //   event.preventDefault();
  //   const draggableId = event.dataTransfer.getData("text/plain");
  //   const draggedElement = document.getElementById(draggableId);
  //   const dropTarget = event.currentTarget;

  //   if (dropTarget === event.target || dropTarget.contains(event.target)) {
  //     dropTarget.appendChild(draggedElement);
  //   }

  //   setIsDragging(false);
  // };

  // const handleDragOver = (event) => {
  //   event.preventDefault();
  // };

  const chartData = [
    {
      url: "https://sample.kmdo.app/widgets/reports/line-chart",
      id: "sources-explorer-panel",
    },
    {
      url: "https://sample.kmdo.app/widgets/reports/pie-chart",
      id: "console-panel",
    },
  ];

  const [data, setData] = useState(chartData);

  const handleDragStart = (e, index) => {
    e.dataTransfer.setData("index", index);
  };

  const handleDrop = (e, dropIndex) => {
    const dragIndex = e.dataTransfer.getData("index");
    const draggedUrl = data[dragIndex];

    const updatedUrls = [...data];
    updatedUrls[dragIndex] = updatedUrls[dropIndex];
    updatedUrls[dropIndex] = draggedUrl;

    setData(updatedUrls);
  };

  return (
    <>
      <div className="flex">
        <div>
          <Sidebar />
        </div>

        <div className="w-full">
          <PanelGroup
            autoSaveId="example"
            direction="horizontal"
            className="dashboardPanel"
          >
            {data.map((item, i) => {
              return (
                <>
                  <Panel
                    defaultSize={50}
                    id={item.id}
                    className="min-w-[20%] border-r-[0.5px] border-[#CDCDCD]"
                  >
                    <div
                      className="h-screen cursor-pointer relative"
                      id="drag-source"
                      draggable
                      onDragStart={(e) => handleDragStart(e, i)}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => handleDrop(e, i)}
                      key={i}
                    >
                      <div className="absolute top-0 left-0 right-0 bottom-0" />
                      <iframe
                        title="line-chart"
                        src={item.url}
                        style={{
                          width: "100%",
                          height: "100%",
                          border: "none",
                        }}
                        allowFullScreen
                      />
                    </div>
                  </Panel>
                  <PanelResizeHandle />
                </>
              );
            })}
          </PanelGroup>
        </div>
        {/* <div className="flex xl:flex-col w-full h-screen overflow-auto">
          <PanelGroup autoSaveId="example" direction="horizontal">
            <Panel
              defaultSize={50}
              id="sources-explorer-panel"
              className="min-w-[20%] border-r-[0.5px] border-[#CDCDCD]"
            >
              <div
                className=" h-screen  xl:min-h-[78vh] cursor-pointer"

              >
                <iframe
                  title="line-chart"
                  src="https://sample.kmdo.app/widgets/reports/line-chart"
                  style={{ width: "100%", height: "100%", border: "none" }}
                  allowFullScreen
                />
              </div>
            </Panel>
            <PanelResizeHandle />
            <Panel
              defaultSize={50}
              id="console-panel"
            >
              <div
                className=" h-screen  xl:min-h-[78vh] cursor-pointer"

              >
                <iframe
                  title="line-chart"
                  src="https://sample.kmdo.app/widgets/reports/pie-chart"
                  style={{ width: "100%", height: "100%", border: "none" }}
                  allowFullScreen
                />
              </div>
            </Panel>
          </PanelGroup>
        </div> */}
      </div>
    </>
  );
};

export default Dashboard;
